import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import { LanguageService } from '../../../../../../../shared/services/language.service';
import { TimeFormatPipe } from 'src/app/shared/pipes/time-format.pipe';

@Component({
  selector: 'app-edit-transport-logtimes',
  templateUrl: './edit-transport-logtimes.component.html',
  styleUrls: ['./edit-transport-logtimes.component.css']
})
export class EditTransportLogtimesComponent implements OnInit {

  @Input() gridDataSource: any;
  @Input() date: Date;
  @Input() minusHeight: number = 650;

  headerTitle = "";
  style: string; 


  constructor(public languageService: LanguageService) { }

  ngOnInit() {
    let momentdate = moment(this.date).format("DD.MM.YYYY");
    this.headerTitle = this.languageService.LNG("Label.Log.Registrations") + " " + momentdate;
    this.style = `padding-bottom: 10px; height: calc(100vh - ${this.minusHeight}px)`
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift( 
    {
      location: 'before',
      template: 'headerTitle'
    });
  }

  timeCellTemplate(container: any, options: any) {
    const value = new TimeFormatPipe().transform(options.value);
    container.textContent = value;
  }

}
